type StatusFilterRange = { min: number; max: number };

export const getRenewalStatusFilterRange = (selected: number[]): StatusFilterRange[] => {
  const minMap: Record<number, number | undefined> = {
    7: Number.NEGATIVE_INFINITY,
    30: 8,
    31: Number.POSITIVE_INFINITY
  };
  const valueRanges: StatusFilterRange[] = [];

  if (selected.length === 0) {
    return valueRanges;
  }

  if (selected[0]) {
    let currentMin = minMap[selected[0]] ?? 0;
    let currentMax = selected[0];

    if (currentMin !== undefined && currentMax !== undefined) {
      for (let i = 1; i < selected.length; i++) {
        const prev = selected[i - 1];
        const curr = selected[i];

        if (curr !== undefined && prev !== undefined) {
          if (curr - prev === prev - (minMap[prev] ?? 0)) {
            currentMax = curr;
          } else {
            valueRanges.push({ min: currentMin, max: currentMax });
            currentMin = minMap[curr] ?? 0;
            currentMax = curr;
          }
        }
      }

      if (currentMin === Number.POSITIVE_INFINITY) {
        valueRanges.push({ min: currentMax, max: currentMin });
      } else {
        valueRanges.push({ min: currentMin, max: currentMax });
      }
    }
  }

  return valueRanges;
};

export const renewalStatusContentReplacer = (content: string) => {
  switch (content) {
    case 'Due in 7 days or less':
      return 'Due ≤ 7 days';
    case 'Due in 30 days or less':
      return 'Due ≤ 30 days';
    case 'Due in 31 days or more':
      return 'Due ≥ 31 days';
    default:
      break;
  }
};
